// extracted by mini-css-extract-plugin
export default {"TextButton":"TextButton--aNsfI"};